/*!
 * @w.dental/request v0.1.1
 * (c) W-Dental
 * Released under the MIT License.
 */
import { __rest, __assign, __awaiter, __generator } from 'tslib';

var objectToQueryString = function objectToQueryString(params) {
  return params ? "?" + new URLSearchParams(params).toString() : '';
};

var getFormatedUrl = function getFormatedUrl(_a) {
  var url = _a.url,
      params = _a.params;
  return "" + url + (url.endsWith('/') ? '' : '/') + objectToQueryString(params);
};

var validateRequest = function validateRequest(_a) {
  var body = _a.body,
      _b = _a.method,
      method = _b === void 0 ? '' : _b;

  if (['patch', 'put'].includes(method) && !body) {
    throw new Error("A " + method + " request must have a body");
  }
};

var doRequest = function doRequest(_a) {
  var url = _a.url,
      _b = _a.options,
      options = _b === void 0 ? {} : _b,
      _c = _a.config,
      _d = _c === void 0 ? {} : _c,
      _e = _d.headers,
      headers = _e === void 0 ? new Headers() : _e,
      _f = _d.interceptors,
      interceptors = _f === void 0 ? {} : _f;

  validateRequest(options);
  return fetch(url, __assign({
    headers: headers
  }, options)).then(function (response) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (response.ok) return [2
            /*return*/
            , response.json()];
            return [4
            /*yield*/
            , response.json()];

          case 1:
            throw _a.sent();
        }
      });
    });
  }).then(function (result) {
    return (interceptors === null || interceptors === void 0 ? void 0 : interceptors.transformResponse) ? interceptors.transformResponse(result) : result;
  }).catch(function (error) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (interceptors === null || interceptors === void 0 ? void 0 : interceptors.onError) return [2
        /*return*/
        , interceptors.onError(error)];
        throw error;
      });
    });
  });
};

var handler = function handler(baseUrl, method, config) {
  return function (_a) {
    var _b = _a.options,
        options = _b === void 0 ? {} : _b,
        params = _a.params,
        url = _a.url;

    var body = options.body,
        restOptions = __rest(options, ["body"]);

    return doRequest({
      url: getFormatedUrl({
        url: baseUrl + url,
        params: params
      }),
      options: __assign(__assign({}, restOptions), {
        method: method,
        body: typeof body === 'object' ? JSON.stringify(body) : body
      }),
      config: config
    });
  };
};

var request = function request(baseUrl, config) {
  return {
    get: handler(baseUrl, 'get', config),
    post: handler(baseUrl, 'post', config),
    put: handler(baseUrl, 'put', config),
    patch: handler(baseUrl, 'patch', config),
    del: handler(baseUrl, 'delete', config)
  };
};

export default request;
export { doRequest, getFormatedUrl, objectToQueryString };